import { SET_CRM_OBJECTS_TO_EDIT, UPDATE_CRM_OBJECT_PROPERTY, FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED, CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE } from 'ContentEditorUI/redux/actions/actionTypes';
import http from 'hub-http/clients/apiClient';
import { TEXT, RICH_TEXT, GROUP, NUMBER } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { READ_ONLY } from 'ContentEditorUI/redux/reducers/crmObjectEditingReducer';
export const setCrmObjectsToEdit = response => ({
  type: SET_CRM_OBJECTS_TO_EDIT,
  response
});
export const updateCrmObjectProperty = payload => ({
  type: UPDATE_CRM_OBJECT_PROPERTY,
  payload
});
export const setCrmObjectFieldSchemaSuccess = fieldSchema => ({
  type: FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED,
  payload: {
    fieldSchema
  }
});
export const clearModifiedPathsWaitingToSave = () => ({
  type: CLEAR_MODIFIED_PATHS_WAITING_TO_SAVE
});
const CRM_FIELD_TYPE_TO_CMV2_FIELD_TYPE = {
  html: RICH_TEXT,
  text: TEXT,
  textarea: TEXT,
  number: NUMBER,
  calculation_equation: READ_ONLY
};

// Check if a CRM field type can be mapped to a CMV2 field type
const canBeMappedToCmv2FieldType = crmFieldType => {
  return !!CRM_FIELD_TYPE_TO_CMV2_FIELD_TYPE[crmFieldType];
};

// Maps CRM object property types to CMV2 field types
const mapToCmv2FieldType = schemaField => {
  if (schemaField.property.readOnlyValue) {
    return READ_ONLY;
  }
  return CRM_FIELD_TYPE_TO_CMV2_FIELD_TYPE[schemaField.property.fieldType];
};
export const fetchCrmObjectFieldSchema = ({
  objectType
}) => dispatch => {
  return http.get(`properties/v4/${objectType}`, {
    query: {
      showHighlySensitiveProperties: false
    }
  }).then(response => {
    // Filter out fields that can't be mapped to CMV2 field types first
    const cmv2Fields = response.filter(schemaField => schemaField.property.readOnlyValue || canBeMappedToCmv2FieldType(schemaField.property.fieldType)).map(schemaField => {
      const fieldType = mapToCmv2FieldType(schemaField);
      const field = {
        name: schemaField.property.name,
        type: fieldType,
        label: schemaField.property.label || schemaField.property.name
      };
      return field;
    });
    const cmv2Schema = {
      [objectType]: [{
        name: 'properties',
        type: GROUP,
        children: cmv2Fields
      }]
    };
    dispatch(setCrmObjectFieldSchemaSuccess(cmv2Schema));
    return cmv2Schema;
  }).catch(error => {
    console.error('Error fetching CRM object field schema:', error);
    throw error;
  });
};